/** @jsxImportSource theme-ui */
import { Box, Text, Flex, Heading, Spinner } from 'theme-ui';
import React from 'react';

type Props = {};

const Section: React.FC<Props> = ({ children, ...props }) => {
    return (
        <Flex backgroundColor="Background" sx={{ flexDirection: 'column', borderRadius: 'sm' }}>
            <Flex
                p="2"
                sx={{
                    gap: 2,
                    '@media only screen and (max-width:60em)': {
                        flexDirection: 'column',
                    },
                    borderRadius: 'sm',
                }}
            >
                <Box
                    sx={{
                        flexBasis: '50%',
                        borderRadius: 'sm',
                        borderStyle: 'solid',
                        borderWidth: '1px',
                        borderColor: 'gray.2',
                        alignSelf: 'flex-start',
                    }}
                    p="3"
                >
                    {children}
                </Box>
            </Flex>
        </Flex>
    );
};

export default Section;
